module.exports = __webpack_public_path__ + "static/media/13.1f2f3638.jpg";